var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-10"},[_c('section',[_c('div',{staticClass:"grid grid-cols-3 gap-5"},[_c('div',{staticClass:"p-5"},[_c('SideNav')],1),_c('div',{staticClass:"col-span-2"},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }